<template lang="pug">
  .view-tags.content
    form-modal(form="team-task-form" :title="modalTitle" v-model="modalValue" @save="storeTeamTask()" @close="closeModal()" :active.sync="isModalActive")
    form-modal(form="edit-team-task-form" :title="editModalTitle" v-model="editModalValue" @save="updateTeamTask()" @close="closeEditModal()" :active.sync="isEditModalActive")

    ui-navbar-panel(title="Задачи сотрудников")
      b-button(type="is-info", class="mr-3", @click="showStats()") Статистика
      b-button(type="is-primary", class="mr-3", @click="showBacklog()") Бэклог
      b-button(type="is-primary", icon-left="plus-circle", @click="newTeamTask(1)") Новая задача

    div.box.mb-0.has-background-white.pb-0.px-6(v-if="isShowBacklog")
      p.is-size-5 Бэклог
        span(v-if="backlogTasks.length") {{ ' (' + backlogTasks.length + ')' }}
        span.is-pulled-right.is-clickable.is-size-6(@click="newBacklogTask") + Новая бэклог-задача
      p.is-italic.has-text-weight-light(v-if="!backlogTasks.length")
        | Нет задач
      div.columns
        div.column.is-one-quarter
          div.box.is-flex.is-justify-content-space-between.mb-2.py-2.pr-2.pl-3(v-if="key<backlogColumnCount", v-for="(task, key) in backlogTasks")
            div.pt-2.is-clickable(@click="editTeamTask(task.id)")
              span
                span(style="font-size: smaller;") # {{ task.id }} &nbsp;
                span.is-size-7(v-if="task.created_at") с {{ task.human_created_at }} &nbsp;
                span.is-size-7(v-if="task.deadline_at", :class="task.is_deadline_end ? 'has-text-danger' : ''") до {{ task.human_deadline_at }} &nbsp;
                span.is-size-7 {{ task.author ? task.author.first_name : '' }} &nbsp;
                br
                | {{ task.title }}
            div
              b-dropdown(aria-role="list", position="is-bottom-left")
                template(#trigger="{ active }")
                  b-button(label="", type="is-light", :icon-right="active ? 'menu-up' : 'menu-down'")
                b-dropdown-item(aria-role="listitem", @click.native="editTeamTask(task.id)") Подробнее...
                b-dropdown-item(aria-role="listitem", @click.native="moveBacklogTaskToTeamTasks(task.id)") Переместить в Задачи
                b-dropdown-item(aria-role="listitem" @click.native="deleteTeamTask(task.id)")
                  span.has-text-danger-dark Удалить
        div.column.is-one-quarter
          div.box.is-flex.is-justify-content-space-between.mb-2.py-2.pr-2.pl-3(v-if="key>=backlogColumnCount&&key<2*backlogColumnCount", v-for="(task, key) in backlogTasks")
            div.pt-2.is-clickable(@click="editTeamTask(task.id)")
              span
                span(style="font-size: smaller;") # {{ task.id }} &nbsp;
                span.is-size-7(v-if="task.created_at") с {{ task.human_created_at }} &nbsp;
                span.is-size-7(v-if="task.deadline_at", :class="task.is_deadline_end ? 'has-text-danger' : ''") до {{ task.human_deadline_at }} &nbsp;
                span.is-size-7 {{ task.author ? task.author.first_name : '' }} &nbsp;
                br
                | {{ task.title }}
            div
              b-dropdown(aria-role="list", position="is-bottom-left")
                template(#trigger="{ active }")
                  b-button(label="", type="is-light", :icon-right="active ? 'menu-up' : 'menu-down'")
                b-dropdown-item(aria-role="listitem", @click.native="editTeamTask(task.id)") Подробнее...
                b-dropdown-item(aria-role="listitem", @click.native="moveBacklogTaskToTeamTasks(task.id)") Переместить в Задачи
                b-dropdown-item(aria-role="listitem" @click.native="deleteTeamTask(task.id)")
                  span.has-text-danger-dark Удалить
        div.column.is-one-quarter
          div.box.is-flex.is-justify-content-space-between.mb-2.py-2.pr-2.pl-3(v-if="key>=2*backlogColumnCount&&key<3*backlogColumnCount", v-for="(task, key) in backlogTasks")
            div.pt-2.is-clickable(@click="editTeamTask(task.id)")
              span
                span(style="font-size: smaller;") # {{ task.id }} &nbsp;
                span.is-size-7(v-if="task.created_at") с {{ task.human_created_at }} &nbsp;
                span.is-size-7(v-if="task.deadline_at", :class="task.is_deadline_end ? 'has-text-danger' : ''") до {{ task.human_deadline_at }} &nbsp;
                span.is-size-7 {{ task.author ? task.author.first_name : '' }} &nbsp;
                br
                | {{ task.title }}
            div
              b-dropdown(aria-role="list", position="is-bottom-left")
                template(#trigger="{ active }")
                  b-button(label="", type="is-light", :icon-right="active ? 'menu-up' : 'menu-down'")
                b-dropdown-item(aria-role="listitem", @click.native="editTeamTask(task.id)") Подробнее...
                b-dropdown-item(aria-role="listitem", @click.native="moveBacklogTaskToTeamTasks(task.id)") Переместить в Задачи
                b-dropdown-item(aria-role="listitem" @click.native="deleteTeamTask(task.id)")
                  span.has-text-danger-dark Удалить
        div.column.is-one-quarter
          div.box.is-flex.is-justify-content-space-between.mb-2.py-2.pr-2.pl-3(v-if="key>=3*backlogColumnCount", v-for="(task, key) in backlogTasks")
            div.pt-2.is-clickable(@click="editTeamTask(task.id)")
              span
                span(style="font-size: smaller;") # {{ task.id }} &nbsp;
                span.is-size-7(v-if="task.created_at") с {{ task.human_created_at }} &nbsp;
                span.is-size-7(v-if="task.deadline_at", :class="task.is_deadline_end ? 'has-text-danger' : ''") до {{ task.human_deadline_at }} &nbsp;
                span.is-size-7 {{ task.author ? task.author.first_name : '' }} &nbsp;
                br
                | {{ task.title }}
            div
              b-dropdown(aria-role="list", position="is-bottom-left")
                template(#trigger="{ active }")
                  b-button(label="", type="is-light", :icon-right="active ? 'menu-up' : 'menu-down'")
                b-dropdown-item(aria-role="listitem", @click.native="editTeamTask(task.id)") Подробнее...
                b-dropdown-item(aria-role="listitem", @click.native="moveBacklogTaskToTeamTasks(task.id)") Переместить в Задачи
                b-dropdown-item(aria-role="listitem" @click.native="deleteTeamTask(task.id)")
                  span.has-text-danger-dark Удалить
    div.box.mb-0.has-background-white.pb-0.px-6(v-if="isShowStats")
      p.p-4.is-size-6(v-if="!isStatsLoading")
        span.mr-4.has-text-dark
          | Активные задачи:
          span.ml-2.mr-2.has-text-black {{ statsCounts.activeCount }}
          | (на тесте: {{ statsCounts.testingCount }}, ожидают пользователя: {{ statsCounts.waitingClientsCount }})
        span.mr-4.has-text-dark
          | Ошибки:
          span.ml-2(:class="(statsCounts.activeBugsCount ? 'has-text-danger' : '')") {{ statsCounts.activeBugsCount }}
        span.mr-4.has-text-dark
          | Ожидают ответ более суток:
          span.ml-2(:class="(statsCounts.warningWaitCount ? 'has-text-danger' : '')") {{ statsCounts.warningWaitCount }}
        span.mr-4.has-text-dark
          | Не закрыты более двух недель:
          span.ml-2(:class="(statsCounts.warningActiveCount ? 'has-text-danger' : '')") {{ statsCounts.warningActiveCount }}

      div.columns
        .column.is-one-third(v-if="!isStatsLoading")
          p.pt-2.has-text-weight-bold.is-size-5
            b-tooltip(label="Без «На тестировании», «Ожидают пользователя» и без ошибок", position="is-right")
              | Основные активные
            span(v-if="statsMainActiveTasks.length") {{ ' (' + statsMainActiveTasks.length + ')' }}
          p.is-italic.has-text-weight-light.has-text-centered(v-if="!statsMainActiveTasks.length")
            | Нет
          div.box.is-flex.is-justify-content-space-between.mb-2.py-2.pr-2.pl-3.is-clickable(@click="routeToTaskById(task.id)")(v-for="(task, key) in statsMainActiveTasks")
            div.pt-2
              span
                b-tooltip(:label="task.status ? task.status.name : 'неизвестный статус'")
                  span(style="font-size: smaller;", :class="getTaskStatusTextColor(task.status ? task.status.type : '')") # {{ task.id }} &nbsp;
                task-status(v-if="task.status", :status="task.status", tooltip-position="is-right", icon-only)
                b-tooltip(label="Ошибка")
                  b-icon(v-if="task.label_id===2", icon="bug-outline", class="ml-2 mr-0")
                span &nbsp; ({{ task.platform ? task.platform.name : 'нет платформы' }}) &nbsp;
                span.is-size-7(v-if="task.created_at") с {{ task.human_created_at }}, &nbsp;
                span.is-size-7 {{ task.executor ? task.executor.first_name : 'нет исполнителя' }} &nbsp;
                br
                | {{ task.title }}
        .column.is-one-third(v-if="!isStatsLoading")
          p.pt-2.has-text-weight-bold.is-size-5 Ошибки
            span(v-if="statsBugTasks.length") {{ ' (' + statsBugTasks.length + ')' }}
          p.is-italic.has-text-weight-light.has-text-centered(v-if="!statsBugTasks.length")
            | Нет
          div.box.is-flex.is-justify-content-space-between.mb-2.py-2.pr-2.pl-3.is-clickable(@click="routeToTaskById(task.id)")(v-for="(task, key) in statsBugTasks")
            div.pt-2
              span
                b-tooltip(:label="task.status ? task.status.name : 'неизвестный статус'")
                  span(style="font-size: smaller;", :class="getTaskStatusTextColor(task.status ? task.status.type : '')") # {{ task.id }} &nbsp;
                task-status(v-if="task.status", :status="task.status", tooltip-position="is-right", icon-only)
                b-tooltip(label="Ошибка")
                  b-icon(v-if="task.label_id===2", icon="bug-outline", class="ml-2 mr-0")
                span &nbsp; ({{ task.platform ? task.platform.name : 'нет платформы' }}) &nbsp;
                span.is-size-7(v-if="task.created_at") с {{ task.human_created_at }}, &nbsp;
                span.is-size-7 {{ task.executor ? task.executor.first_name : 'нет исполнителя' }} &nbsp;
                br
                | {{ task.title }}
          p.pt-2.has-text-weight-bold.is-size-5 Ожидают ответ пользователя
            span(v-if="statsWaitingClientsTasks.length") {{ ' (' + statsWaitingClientsTasks.length + ')' }}
          p.is-italic.has-text-weight-light.has-text-centered(v-if="!statsWaitingClientsTasks.length")
            | Нет
          div.box.is-flex.is-justify-content-space-between.mb-2.py-2.pr-2.pl-3.is-clickable(@click="routeToTaskById(task.id)")(v-for="(task, key) in statsWaitingClientsTasks")
            div.pt-2
              span
                b-tooltip(:label="task.status ? task.status.name : 'неизвестный статус'")
                  span(style="font-size: smaller;", :class="getTaskStatusTextColor(task.status ? task.status.type : '')") # {{ task.id }} &nbsp;
                task-status(v-if="task.status", :status="task.status", tooltip-position="is-right", icon-only)
                b-tooltip(label="Ошибка")
                  b-icon(v-if="task.label_id===2", icon="bug-outline", class="ml-2 mr-0")
                span &nbsp; ({{ task.platform ? task.platform.name : 'нет платформы' }}) &nbsp;
                span.is-size-7(v-if="task.created_at") с {{ task.human_created_at }}, &nbsp;
                span.is-size-7 {{ task.executor ? task.executor.first_name : 'нет исполнителя' }} &nbsp;
                br
                | {{ task.title }}
          p.pt-2.has-text-weight-bold.is-size-5 На тестировании
            span(v-if="statsOnTestingTasks.length") {{ ' (' + statsOnTestingTasks.length + ')' }}
          p.is-italic.has-text-weight-light.has-text-centered(v-if="!statsOnTestingTasks.length")
            | Нет
          div.box.is-flex.is-justify-content-space-between.mb-2.py-2.pr-2.pl-3.is-clickable(@click="routeToTaskById(task.id)")(v-for="(task, key) in statsOnTestingTasks")
            div.pt-2
              span
                b-tooltip(:label="task.status ? task.status.name : 'неизвестный статус'")
                  span(style="font-size: smaller;", :class="getTaskStatusTextColor(task.status ? task.status.type : '')") # {{ task.id }} &nbsp;
                task-status(v-if="task.status", :status="task.status", tooltip-position="is-right", icon-only)
                b-tooltip(label="Ошибка")
                  b-icon(v-if="task.label_id===2", icon="bug-outline", class="ml-2 mr-0")
                span &nbsp; ({{ task.platform ? task.platform.name : 'нет платформы' }}) &nbsp;
                span.is-size-7(v-if="task.created_at") с {{ task.human_created_at }}, &nbsp;
                span.is-size-7 {{ task.executor ? task.executor.first_name : 'нет исполнителя' }} &nbsp;
                br
                | {{ task.title }}
        .column.is-one-third(v-if="!isStatsLoading")
          p.pt-2.has-text-weight-bold.is-size-5 Ожидают ответ более суток
            span(v-if="statsWarningWaitTasks.length") {{ ' (' + statsWarningWaitTasks.length + ')' }}
          p.is-italic.has-text-weight-light.has-text-centered(v-if="!statsWarningWaitTasks.length")
            | Нет
          div.box.is-flex.is-justify-content-space-between.mb-2.py-2.pr-2.pl-3.is-clickable(@click="routeToTaskById(task.id)")(v-for="(task, key) in statsWarningWaitTasks")
            div.pt-2
              span
                b-tooltip(:label="task.status ? task.status.name : 'неизвестный статус'")
                  span(style="font-size: smaller;", :class="getTaskStatusTextColor(task.status ? task.status.type : '')") # {{ task.id }} &nbsp;
                task-status(v-if="task.status", :status="task.status", tooltip-position="is-right", icon-only)
                b-tooltip(label="Ошибка")
                  b-icon(v-if="task.label_id===2", icon="bug-outline", class="ml-2 mr-0")
                span &nbsp; ({{ task.platform ? task.platform.name : 'нет платформы' }}) &nbsp;
                span.is-size-7(v-if="task.created_at") с {{ task.human_created_at }}, &nbsp;
                span.is-size-7 {{ task.executor ? task.executor.first_name : 'нет исполнителя' }} &nbsp;
                br
                | {{ task.title }}
          p.pt-2.has-text-weight-bold.is-size-5 Не закрыты более двух недель
            span(v-if="statsWarningActiveTasks.length") {{ ' (' + statsWarningActiveTasks.length + ')' }}
          p.is-italic.has-text-weight-light.has-text-centered(v-if="!statsWarningActiveTasks.length")
            | Нет
          div.box.is-flex.is-justify-content-space-between.mb-2.py-2.pr-2.pl-3.is-clickable(@click="routeToTaskById(task.id)")(v-for="(task, key) in statsWarningActiveTasks")
            div.pt-2
              span
                b-tooltip(:label="task.status ? task.status.name : 'неизвестный статус'")
                  span(style="font-size: smaller;", :class="getTaskStatusTextColor(task.status ? task.status.type : '')") # {{ task.id }} &nbsp;
                task-status(v-if="task.status", :status="task.status", tooltip-position="is-right", icon-only)
                b-tooltip(label="Ошибка")
                  b-icon(v-if="task.label_id===2", icon="bug-outline", class="ml-2 mr-0")
                span &nbsp; ({{ task.platform ? task.platform.name : 'нет платформы' }}) &nbsp;
                span.is-size-7(v-if="task.created_at") с {{ task.human_created_at }}, &nbsp;
                span.is-size-7 {{ task.executor ? task.executor.first_name : 'нет исполнителя' }} &nbsp;
                br
                | {{ task.title }}

    div.box.mb-0.has-background-white.pb-0.px-6.is-flex.is-justify-content-space-between
      div
        template(v-for="teamStatus in teamStatuses")
          span(:class="teamStatus.color + ' mr-2 square'")
          span(class="mr-2 va-middle") {{ teamStatus.name }} &nbsp;
      div
        span.pl-2.mr-3.is-clickable.has-text-grey(@click="setIsShowDraftTeamTasks(0)" v-if="isShowDraftTeamTasks==1") Скрыть черновики
        span.pl-2.mr-3.is-clickable.has-text-grey(@click="setIsShowDraftTeamTasks(1)" v-else) Показать черновики
        span.pl-2.is-clickable(:class="sortType === 'id' ? '' : 'has-text-grey-light'", @click="sortTeamTasks('id')") Сорт: &nbsp; по id
        span.pl-2.is-clickable(:class="sortType === 'status' ? '' : 'has-text-grey-light'", @click="sortTeamTasks('status')")  по статусу

    div.columns.py-4.px-6
      div.column.is-one-quarter(v-for="(executorName, executorId) in executors" :key="executorId")
        div.box.is-flex.is-justify-content-space-between.mb-2.py-2
          div
            span.is-size-5
              | {{ executorName }}
            b-tooltip(label="Задачи")
              span(class="ml-2") {{ getActiveTeamTasksCount(executorId) }}/
            b-tooltip(label="Тикеты")
              span(class="ml-2-d") {{ getActiveHelpdeskTasksCount(executorId) }}
          div
            b-tooltip(label="Создать задачу")
              b-icon(icon="plus", class="is-clickable mr-4", @click.native="newTeamTask(executorId)")
            b-tooltip(label="Сообщить об изменениях на email")
              b-icon(icon="bullhorn", class="is-clickable", @click.native="sendEmail(executorId)")

        p.pt-2 Задачи ({{ getActiveTeamTasksCount(executorId) }})

        template(v-if="sortType==='id'")
          div.box.is-flex.is-justify-content-space-between.mb-2.py-2.pr-2.pl-3(v-if="task.executor_id===+executorId && isShowDraftTeamTask(task)" v-for="(task, key) in teamTasks")
            div.pt-2.is-clickable(@click="editTeamTask(task.id)")
              span
                b-tooltip(:label="task.statusTeamLabel")
                  span(style="font-size: smaller;", :class="task.statusTeamTextColor") # {{ task.id }} &nbsp;
                b-tooltip(v-if="task.isHelpdeskTask && task.is_team" label="Тикет из хелпдеска")
                  task-status(v-if="task.status", :status="task.status", tooltip-position="is-right", icon-only)
                span &nbsp;
                span(v-if="task.isHelpdeskTask && task.is_team") ({{ task.platformName ? task.platformName : 'нет платформы' }}) &nbsp;
                span.is-size-7(v-if="task.created_at") с {{ task.human_created_at }} &nbsp;
                span.is-size-7(v-if="task.deadline_at", :class="task.is_deadline_end ? 'has-text-danger' : ''") до {{ task.human_deadline_at }} &nbsp;
                br
                | {{ task.title }}
            div
              b-dropdown(aria-role="list", position="is-bottom-left")
                template(#trigger="{ active }")
                  b-button(label="", type="is-light", :icon-right="active ? 'menu-up' : 'menu-down'")
                b-dropdown-item(aria-role="listitem", @click.native="editTeamTask(task.id)") Подробнее...
                b-dropdown-item(v-if="task.isHelpdeskTask && task.is_team", aria-role="listitem", @click.native="removeHelpdeskTaskFromTeamTasks(task.id)") Вернуть в тикеты
                template(v-for="(teamStatus, key) in teamStatuses")
                  b-dropdown-item(v-if="key!==task.team_status", aria-role="listitem", @click.native="updateTeamTaskStatus(task.id, key)") {{ teamStatus.name }}
                b-dropdown-item(v-if="task.isTeamTask", aria-role="listitem") &nbsp;
                b-dropdown-item(v-if="task.isTeamTask", aria-role="listitem", @click.native="moveTeamTaskToBacklogTasks(task.id)") Переместить в Бэклог
                b-dropdown-item(v-if="task.isTeamTask", aria-role="listitem" @click.native="deleteTeamTask(task.id)")
                  span.has-text-danger-dark Удалить
        template(v-if="sortType==='status'")
          template(v-for="sortedTeamStatus in sortedTeamStatuses")
            div.box.is-flex.is-justify-content-space-between.mb-2.py-2.pr-2.pl-3(v-if="sortedTeamStatus === task.team_status && task.executor_id===+executorId && isShowDraftTeamTask(task)" v-for="(task, key) in teamTasks")
              div.pt-2.is-clickable(@click="editTeamTask(task.id)")
                span
                  b-tooltip(:label="task.statusTeamLabel")
                    span(style="font-size: smaller;", :class="task.statusTeamTextColor") # {{ task.id }} &nbsp;
                  b-tooltip(v-if="task.isHelpdeskTask && task.is_team" label="Тикет из хелпдеска")
                    task-status(v-if="task.status", :status="task.status", tooltip-position="is-right", icon-only)
                  span &nbsp;
                  span(v-if="task.isHelpdeskTask && task.is_team") ({{ task.platformName ? task.platformName : 'нет платформы' }}) &nbsp;
                  span.is-size-7(v-if="task.created_at") с {{ task.human_created_at }} &nbsp;
                  span.is-size-7(v-if="task.deadline_at", :class="task.is_deadline_end ? 'has-text-danger' : ''") до {{ task.human_deadline_at }} &nbsp;
                  br
                  | {{ task.title }}
              div
                b-dropdown(aria-role="list", position="is-bottom-left")
                  template(#trigger="{ active }")
                    b-button(label="", type="is-light", :icon-right="active ? 'menu-up' : 'menu-down'")
                  b-dropdown-item(aria-role="listitem", @click.native="editTeamTask(task.id)") Подробнее...
                  b-dropdown-item(v-if="task.isHelpdeskTask && task.is_team", aria-role="listitem", @click.native="removeHelpdeskTaskFromTeamTasks(task.id)") Вернуть в тикеты
                  template(v-for="(teamStatus, key) in teamStatuses")
                    b-dropdown-item(v-if="key!==task.team_status", aria-role="listitem", @click.native="updateTeamTaskStatus(task.id, key)") {{ teamStatus.name }}
                  b-dropdown-item(v-if="task.isTeamTask", aria-role="listitem") &nbsp;
                  b-dropdown-item(v-if="task.isTeamTask", aria-role="listitem", @click.native="moveTeamTaskToBacklogTasks(task.id)") Переместить в Бэклог
                  b-dropdown-item(v-if="task.isTeamTask", aria-role="listitem" @click.native="deleteTeamTask(task.id)")
                    span.has-text-danger-dark Удалить

        p.pt-2 Тикеты ({{ getActiveHelpdeskTasksCount(executorId) }})

        div.box.is-flex.is-justify-content-space-between.mb-2.py-2.pr-2.pl-3(v-if="task.executor_id===+executorId" v-for="(task, key) in helpdeskTasks")
          div.pt-2.is-clickable(@click="editTeamTask(task.id)")
            span
              b-tooltip(:label="task.status.name")
                span(style="font-size: smaller;", :class="task.statusTextColor") # {{ task.id }} &nbsp;
              task-status(v-if="task.status", :status="task.status", tooltip-position="is-right", icon-only)
              b-tooltip(label="Ошибка")
                b-icon(v-if="task.is_bug", icon="bug-outline", class="ml-2 mr-0")
              span &nbsp; ({{ task.platformName ? task.platformName : 'нет платформы' }}) &nbsp;
              span.is-size-7(v-if="task.created_at") с {{ task.human_created_at }} &nbsp;
              span.is-size-7(v-if="task.deadline_at", :class="task.is_deadline_end ? 'has-text-danger' : ''") до {{ task.human_deadline_at }} &nbsp;
              br
              | {{ task.title }}
          div
            b-dropdown(aria-role="list", position="is-bottom-left")
              template(#trigger="{ active }")
                b-button(label="", type="is-light", :icon-right="active ? 'menu-up' : 'menu-down'")
              b-dropdown-item(aria-role="listitem", @click.native="editTeamTask(task.id)") Подробнее...
              b-dropdown-item(aria-role="listitem", @click.native="moveHelpdeskTaskToTeamTasks(task.id)") Перевести в задачи

        p.pt-2.pb-0.mb-0 Выполненные задачи и тикеты

        template(v-for="dayDoneTasks in daysDoneTasks")
          p.pt-2.has-text-centered(v-if="hasExecutorTasks(executorId, dayDoneTasks[1])")
            | {{ dayDoneTasks[0] | dayFormat }}

          template(v-for="task in dayDoneTasks[1]")
            div.box.is-flex.is-justify-content-space-between.mb-2.py-2.pr-2.pl-3(v-if="task.executor_id===+executorId")
              template(v-if="task.isHelpdeskTask")
                div.pt-2.is-clickable(@click="editDoneTeamTask(task.id)")
                  span
                    b-tooltip(:label="task.status.name")
                      span(style="font-size: smaller;", :class="task.statusTextColor") # {{ task.id }} &nbsp;
                    task-status(v-if="task.status", :status="task.status", tooltip-position="is-right", icon-only)
                    b-tooltip(label="Ошибка")
                      b-icon(v-if="task.is_bug", icon="bug-outline", class="ml-2 mr-0")
                    span &nbsp; ({{ task.platformName ? task.platformName : 'нет платформы' }}) &nbsp;
                    | {{ task.title }}
                div
                  b-dropdown(aria-role="list", position="is-bottom-left")
                    template(#trigger="{ active }")
                      b-button(label="", type="is-light", :icon-right="active ? 'menu-up' : 'menu-down'")
                    b-dropdown-item(aria-role="listitem" @click.native="editDoneTeamTask(task.id)") Подробнее...

              template(v-else)
                div.pt-2.is-clickable(@click="editDoneTeamTask(task.id)")
                  span
                    b-tooltip(:label="task.statusLabel")
                      span(style="font-size: smaller;", :class="task.statusTextColor") # {{ task.id }} &nbsp;
                    b-tooltip(v-if="task.isHelpdeskTask && task.is_team" label="Тикет из хелпдеска")
                      task-status(v-if="task.status", :status="task.status", tooltip-position="is-right", icon-only)
                    span &nbsp;
                    span(v-if="task.isHelpdeskTask && task.is_team") ({{ task.platformName ? task.platformName : 'нет платформы' }})
                    | {{ task.title }}
                div
                  b-dropdown(aria-role="list", position="is-bottom-left")
                    template(#trigger="{ active }")
                      b-button(label="", type="is-light", :icon-right="active ? 'menu-up' : 'menu-down'")
                    b-dropdown-item(aria-role="listitem" @click.native="editDoneTeamTask(task.id)") Подробнее...

        div(style="height: 250px;")
</template>

<script>
import TeamTask from '@/models/TeamTask';
import {ToastProgrammatic as Toast} from 'buefy';
import api from '@/api';
import DateHelper from '@/helpers/date';
import ObjectHelper from '@/helpers/object';
import {mapGetters} from "vuex";
import TaskFile from '@/models/TaskFile';

export default {
  name: 'view-team-tasks',

  data: () => ({
    tasks: TeamTask.collection(),
    doneTasks: TeamTask.collection(),
    modalTitle: null,
    modalValue: null,
    isModalActive: false,
    editModalTitle: null,
    editModalValue: null,
    isEditModalActive: false,
    isShowDraftTeamTasks: 0,
    executors: [],
    teamStatuses: [],
    sortedTeamStatuses: [],
    sortType: null,
    statsCounts: {
      activeCount: 0,
      warningActiveCount: 0,
      warningWaitCount: 0,
      activeBugsCount: 0,
      testingCount: 0,
      waitingClientsCount: 0,
    },
    statsBugTasks: [],
    statsWarningWaitTasks: [],
    statsWarningActiveTasks: [],
    statsOnTestingTasks: [],
    statsWaitingClientsTasks: [],
    statsMainActiveTasks: [],
    isStatsLoading: true,
    isShowStats: false,
    isBacklogLoading: true,
    isShowBacklog: false,
  }),

  computed: {
    ...mapGetters(['user']),

    helpdeskTasks() {
      return this.tasks.items.filter(task => {
        return task.isHelpdeskTask && !task.is_team && task.is_bug;
      }).concat(this.tasks.items.filter(task => {
        return task.isHelpdeskTask && !task.is_team && !task.is_bug;
      }));
    },

    teamTasks() {
      return this.tasks.items.filter(task => {
        return task.isTeamTask || (task.isHelpdeskTask && task.is_team);
      });
    },

    backlogTasks() {
      return this.tasks.items.filter(task => {
        return task.isBacklogTask;
      });
    },

    backlogColumnCount() {
      return Math.ceil(this.backlogTasks.length/4);
    },

    daysDoneTasks() {
      let items = this.doneTasks.items.filter(task => {
        return task.done_at;
      });

      items.sort((a, b) => {
        return DateHelper.compareDatesAsString(a.done_at, b.done_at);
      });

      return ObjectHelper.objectToArray(ObjectHelper.groupBy(items, 'done_at'));
    },
  },

  methods: {
    loadTasks() {
      return this.tasks.$fetch({scope: 'forTeam', include: 'status,platform,author,files'}).then(() => {
        this.doneTasks.$fetch({scope: 'forDoneTeam', include: 'status,platform,author,files'});
      });
    },

    loadStats() {
      api
        .for('helpdesk')
        .read('stat/common')
        .then(({ data }) => {

          this.statsCounts.activeBugsCount = data.stats.active_bugs_count;
          this.statsCounts.activeCount = data.stats.active_count;
          this.statsCounts.testingCount = data.stats.testing_count;
          this.statsCounts.warningActiveCount = data.stats.warning_active_count;
          this.statsCounts.warningWaitCount = data.stats.warning_wait_count;
          this.statsCounts.waitingClientsCount = data.stats.waiting_clients_count;

          this.statsBugTasks = data.active_bug_tasks;
          this.statsWarningActiveTasks = data.warning_active_tasks;
          this.statsWarningWaitTasks = data.warning_wait_tasks;
          this.statsOnTestingTasks = data.testing_active_tasks;
          this.statsWaitingClientsTasks = data.waiting_clients_tasks;
          this.statsMainActiveTasks = data.main_active_tasks;

          this.isStatsLoading = false;
        });
    },

    routeToTaskById(id) {
      window.open(this.$router.resolve({name: 'task', params: {id}}).href);
    },

    showStats() {
      this.isShowStats = !this.isShowStats;
    },

    showBacklog() {
      this.isShowBacklog = !this.isShowBacklog;
    },

    sendEmail(executorId = 1) {
      api
        .for('team-tasks')
        .read('send-notification', {executor_id: executorId})
        .then(() => {
          Toast.open({
            type: 'is-success',
            duration: 4000,
            message: new TeamTask({executor_id: executorId}).executorName + ' оповещен об изменениях в задачах',
            queue: false,
          });
        });
    },

    getActiveTeamTasksCount(executorId) {
      return this.tasks.items.filter((task) => {
        return (task.isTeamTask || (task.isHelpdeskTask && task.is_team)) &&
          task.isTeamActive && task.executor_id === +executorId;
      }).length;
    },

    getActiveHelpdeskTasksCount(executorId) {
      return this.tasks.items.filter((task) => {
        return task.isHelpdeskTask && !task.is_team && task.executor_id === +executorId;
      }).length;
    },

    getTaskStatusTextColor(taskStatusType) {
      const color = (new TeamTask()).helpdeskStatusColors[taskStatusType];
      return color ? color.replace('background', 'text') : '';
    },

    hasExecutorTasks(executorId, tasks) {
      for (const task of tasks) {
        if (task.executor_id === +executorId) {
          return true;
        }
      }
      return false;
    },

    closeModal() {
      this.isModalActive = false;
      this.modalValue.$reset();
    },

    closeEditModal() {
      this.isEditModalActive = false;
      this.editModalValue.$reset();
    },

    updateTeamTask() {
      this.editModalValue.$save().then(() => {
        this.loadTasks();
        this.isEditModalActive = false;
        Toast.open({
          type: 'is-success',
          duration: 5000,
          message: 'Изменения сохранены',
          queue: false,
        });
      });
    },

    newTeamTask(executorId = 1) {
      this.modalTitle = 'Новая задача';
      this.modalValue = new TeamTask({team_status: 'wait', executor_id: executorId});
      this.isModalActive = true;
    },

    newBacklogTask() {
      this.modalTitle = 'Новая бэклог-задача';
      this.modalValue = new TeamTask({team_status: 'wait', executor_id: 1, type: 'backlog'});
      this.isModalActive = true;
    },

    storeTeamTask() {
      if (this.modalValue.title.trim() === '') {
        Toast.open({
          type: 'is-danger',
          duration: 5000,
          message: 'Не указан заголовок задачи',
          queue: false,
        });
        return;
      }
      let files = this.modalValue.files;
      this.modalValue.files = null;
      this.modalValue.$save().then(({data}) => {
        files.forEach(file => {
          let taskFile = TaskFile.makeFromFile(file, {
            task_id: data.id,
            task_message_id: 0,
          });
          taskFile.$save();
        });
        this.loadTasks();
        this.isModalActive = false;
        Toast.open({
          type: 'is-success',
          duration: 5000,
          message: 'Задача #' + data.id + ' создана',
          queue: false,
        });
      });
    },

    editTeamTask(id) {
      this.editModalValue = this.tasks.find(id);
      if (this.editModalValue.isTeamTask) {
        this.editModalTitle = 'Задача #' + id;
      } else if (this.editModalValue.isHelpdeskTask) {
        this.editModalTitle = 'Тикет #' + id;
      } else {
        this.editModalTitle = '#' + id;
      }
      this.isEditModalActive = true;
    },

    editDoneTeamTask(id) {
      this.editModalValue = this.doneTasks.find(id);
      if (this.editModalValue.isTeamTask) {
        this.editModalTitle = 'Задача #' + id;
      } else if (this.editModalValue.isHelpdeskTask) {
        this.editModalTitle = 'Тикет #' + id;
      } else {
        this.editModalTitle = '#' + id;
      }
      this.isEditModalActive = true;
    },

    deleteTeamTask(id) {
      this.tasks.$delete(id);
    },

    removeHelpdeskTaskFromTeamTasks(taskId) {
      api
        .for('team-tasks')
        .read('from-team-to-helpdesk', {task_id: taskId})
        .then(() => {
          this.loadTasks();
          Toast.open({
            type: 'is-success',
            duration: 4000,
            message: 'Тикет успешно возвращен',
            queue: false,
          });
        });
    },

    moveBacklogTaskToTeamTasks(taskId) {
      api
        .for('team-tasks')
        .read('from-backlog-to-team', {task_id: taskId})
        .then(() => {
          this.loadTasks();
          Toast.open({
            type: 'is-success',
            duration: 4000,
            message: 'Задача успешно перемещена из Бэклога',
            queue: false,
          });
        });
    },

    moveTeamTaskToBacklogTasks(taskId) {
      api
        .for('team-tasks')
        .read('from-team-to-backlog', {task_id: taskId})
        .then(() => {
          this.loadTasks();
          Toast.open({
            type: 'is-success',
            duration: 4000,
            message: 'Задача успешно перемещена в Бэклог',
            queue: false,
          });
        });
    },

    moveHelpdeskTaskToTeamTasks(taskId) {
      api
        .for('team-tasks')
        .read('from-helpdesk-to-team', {task_id: taskId})
        .then(() => {
          this.loadTasks();
          Toast.open({
            type: 'is-success',
            duration: 4000,
            message: 'Тикет успешно перемещен',
            queue: false,
          });
        });
    },

    updateTeamTaskStatus(taskId, status) {
      api
        .for('team-tasks')
        .read('status', {task_id: taskId, status: status})
        .then(() => {
          this.loadTasks();
          Toast.open({
            type: 'is-success',
            duration: 4000,
            message: 'Статус успешно изменен',
            queue: false,
          });
        });
    },

    sortTeamTasks(type) {
      localStorage.setItem('helpdesk_team_tasks_sort_type', type);
      if (this.sortType !== type) {
        this.sortType = type;
        this.loadTasks();
      }
    },

    isShowDraftTeamTask(task) {
      return !(this.isShowDraftTeamTasks==0 && !task.isHelpdeskTask && task.isTeamDraft);
    },

    setSortType() {
      if (localStorage.hasOwnProperty('helpdesk_team_tasks_sort_type')) {
        this.sortType = localStorage.getItem('helpdesk_team_tasks_sort_type');
      } else {
        this.sortType = 'status';
      }
    },

    setIsShowDraftTeamTasks(value) {
      this.isShowDraftTeamTasks = value;
      localStorage.setItem('helpdesk_team_tasks_is_show_draft_team_tasks', this.isShowDraftTeamTasks);
    },
  },

  created() {
    this.setSortType();

    if (localStorage.hasOwnProperty('helpdesk_team_tasks_is_show_draft_team_tasks')) {
      this.isShowDraftTeamTasks = localStorage.getItem('helpdesk_team_tasks_is_show_draft_team_tasks');
    } else {
      this.setIsShowDraftTeamTasks(0);
    }

    this.loadTasks().then(() => {
      const teamTask = new TeamTask();
      this.executors = teamTask.executors;
      this.teamStatuses = teamTask.teamStatuses;
      this.sortedTeamStatuses = teamTask.sortedTeamStatuses;

      this.loadStats();
    });
  },
};
</script>

<style scoped>
.square {
  width: 16px;
  height: 16px;
  display: inline-block;
  vertical-align: middle;
}

.va-middle {
  vertical-align: middle;
}
</style>
